import { render, staticRenderFns } from "./setting-invoice.vue?vue&type=template&id=7243fc6b&scoped=true&"
import script from "./setting-invoice.vue?vue&type=script&lang=js&"
export * from "./setting-invoice.vue?vue&type=script&lang=js&"
import style0 from "./setting-invoice.vue?vue&type=style&index=0&id=7243fc6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7243fc6b",
  null
  
)

export default component.exports